
import { Vue, Component } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component({
  name: 'QualificationDisclaimer',
})
export default class QualificationDisclaimer extends Vue {
  @State('qualConfig', { namespace: 'qualification' }) qualConfig: any

  get disclaimerContent() {
    const {extraTips} = this.qualConfig?.fieldText || {}
    return extraTips?.disclaimer?.i18n || ''
  }
}
